export class Request {

    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data) {
        return {
            visible: true,
            activeStep: 0,
            nombre_servicio: data.nombre_servicio,
            data: {},
            resolveBody: (values, props) => {
                return {
                    url: `/marketplace/${props.farmId}/create-request`,
                    body: {
                        message: values.message,
                        marketplace_servicio_id: data.marketplace_servicio_id
                    }
                };
            },
            steps: [
                {
                    label: t("sass.conectar"),
                    inputs: [
                        {
                            label: t("marketplace.requestMessage"),
                            campo: "message",
                            component: "textArea",
                        },
                    ],
                },
            ],
        };
    }
}
